export default {
    data: () => ({
        translations: {
            title: {
                el: "Λογότυπο Επιχείρησης",
                en: "Business Logo",
                it: "Logo del business"
            },
            info: {
                el: "Μπορείτε να ανεβάσετε εδώ το λογότυπο της επιχείρησής σας, το οποίο θα εμφανίζεται στην εφαρμογή και θα υπάρχει στις φυσικές κάρτες. Εάν πιστεύουμε ότι μπορεί να βελτιωθεί, θα επικοινωνήσουμε μαζί σας πριν από τη δημοσίευση.",
                en: `Upload the logo of your business to appear on the app and printed on physical cards. If the dimensions are not ideal, we will contact you before publishing. `,
                it: "Qui puoi caricare il logo della tua azienda, che sarà visualizzato nell'app e sulle carte fisiche. Se pensiamo che possa essere migliorato, vi contatteremo prima di pubblicarlo."
            },
            uploadText: {
                el: "Πατήστε στο κουμπί για να επιλέξετε εικόνα:",
                en: "Click inside the field to open the file selection tab:",
                it: "Tocca il pulsante per selezionare un'immagine:"
            },
            validationError: {
                el: "Για να συνεχίσετε πρέπει να ανεβάσετε μια νέα εικόνα",
                en: "To continue you must upload a new image",
                it: "Per continuare è necessario caricare una nuova immagine"
            }
        }
    })
};
